import React from 'react'
import summer_lassi from "../images/LASSI.jpg";
import summermocktail from "../images/summer.jpg"
import momospecialkrishnagar from "../images/Momo.jpg";
import burger from "../images/Home_slide.jpg";
import Drink from "../images/Blue Drink.jpg"


function SliderHome() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={summer_lassi} className="d-block w-100" alt="summer_lassi"/>
    </div>
    <div className="carousel-item">
      <img src={summermocktail} className="d-block w-100" alt="summermocktailkrishnagar"/>
    </div>
    <div className="carousel-item">
            <img src={Drink} className="d-block w-100" alt="The Love Bird's Icecream"/>

    </div>
     <div className="carousel-item">
            <img src={burger} className="d-block w-100" alt="burger"/>

    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default SliderHome